import { CRM_SUITE_STARTER_BUNDLE, MARKETING_HUB_STARTER } from 'self-service-api/constants/ApiNames';
import { POINT_TYPES } from '../ums/types';
// Hardcoding to simplify. This matches this config: https://tools.hubteamqa.com/ums/upgrade-points/mc-0653-banner
export const MC0653_BANNER_UPGRADE_CONFIG = {
  upgradeKey: 'mc-0653-banner',
  bestFitApiNameForPurchase: CRM_SUITE_STARTER_BUNDLE,
  apiNames: [CRM_SUITE_STARTER_BUNDLE, MARKETING_HUB_STARTER],
  featureStoreFeature: 'emailMarketing',
  team: 'hs-monetization-core-fe',
  featureTranslationKey: 'mc0653',
  pointType: POINT_TYPES.USAGE_LIMIT_BANNER,
  status: 'ACTIVE',
  title: null,
  subtitle: null,
  visualType: null,
  visualKey: null,
  pointLocation: '',
  recommendationResponse: null,
  purchaseMotions: [],
  descriptions: []
};

// Hardcoding to simplify. This matches this config: https://tools.hubteamqa.com/ums/upgrade-points/mc-0653-email-sends-counter?isNew=true
export const MC0653_EMAIL_SENDS_UPGRADE_CONFIG = {
  upgradeKey: 'mc-0653-email-sends-counter',
  bestFitApiNameForPurchase: CRM_SUITE_STARTER_BUNDLE,
  apiNames: [CRM_SUITE_STARTER_BUNDLE, MARKETING_HUB_STARTER],
  featureStoreFeature: 'emailMarketing',
  team: 'hs-monetization-core-fe',
  featureTranslationKey: 'mc0653',
  pointType: POINT_TYPES.USAGE_LIMIT_BANNER,
  status: 'ACTIVE',
  title: null,
  subtitle: null,
  visualType: null,
  visualKey: null,
  pointLocation: '',
  recommendationResponse: null,
  purchaseMotions: [],
  descriptions: []
};

// Hardcoding to simplify. This matches this config: https://tools.hubteamqa.com/ums/upgrade-points/mc-0653-email-sends-counter?isNew=true
export const MC0653_SENDING_OPTIONS_UPGRADE_CONFIG = {
  upgradeKey: 'mc-0653-sending-options',
  bestFitApiNameForPurchase: CRM_SUITE_STARTER_BUNDLE,
  apiNames: [CRM_SUITE_STARTER_BUNDLE, MARKETING_HUB_STARTER],
  featureStoreFeature: 'emailMarketing',
  team: 'hs-monetization-core-fe',
  featureTranslationKey: 'mc0653',
  pointType: POINT_TYPES.USAGE_LIMIT_BANNER,
  status: 'ACTIVE',
  title: null,
  subtitle: null,
  visualType: null,
  visualKey: null,
  pointLocation: '',
  recommendationResponse: null,
  purchaseMotions: [],
  descriptions: []
};